import { createContext } from 'react'

export enum LIST_TEMPLATE {
  DISC = 'disc',
  CHECK = 'check',
}

export const ListTemplateContext = createContext(LIST_TEMPLATE.DISC)
